module.exports = __webpack_public_path__ + "img/tour-20.12005bbe.png";